var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader",class:_vm.ifLoading},[_c('TheSpinner')],1),(_vm.loading)?_c('div',[_c('div',{staticClass:"content"},[(_vm.items[1].template == 1)?_c('formular_anmeldung'):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }